import gql from 'graphql-tag'

import { Query } from '../types-graphql'

export type TDataLearningPaths = Pick<Query, 'learningPaths' | '__typename'>
export const LEARNING_PATHS = gql`
  query LearningPaths(
    $q: LearningPathRansack
    $page: Int
    $perPage: Int
    $search: String
  ) {
    learningPaths(page: $page, perPage: $perPage, search: $search, q: $q) {
      nodes {
        id
        name
        usersCount
        coursesCount
        monitoring {
          usersFinish
          usersInProgress
          usersPending
        }
        profiles {
          id
          name
          code
          color
        }
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export type TDataLearningPathsCount = {
  learningPaths: {
    nodesCount: number
  }
}
export const LEARNING_PATHS_COUNT = gql`
  query LearningPaths {
    learningPaths {
      nodesCount
    }
  }
`
